// source: exLedger.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.ExLedger', null, global);
goog.exportSymbol('proto.common.model.ExLedger.Data', null, global);
goog.exportSymbol('proto.common.model.ExLedger.Item', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExLedger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExLedger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExLedger.displayName = 'proto.common.model.ExLedger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExLedger.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExLedger.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExLedger.Item.displayName = 'proto.common.model.ExLedger.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExLedger.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.ExLedger.Data.repeatedFields_, null);
};
goog.inherits(proto.common.model.ExLedger.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExLedger.Data.displayName = 'proto.common.model.ExLedger.Data';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExLedger.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExLedger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExLedger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.toObject = function(includeInstance, msg) {
  var f, obj = {
exchange: jspb.Message.getFieldWithDefault(msg, 1, 0),
data: (f = msg.getData()) && proto.common.model.ExLedger.Data.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExLedger}
 */
proto.common.model.ExLedger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExLedger;
  return proto.common.model.ExLedger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExLedger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExLedger}
 */
proto.common.model.ExLedger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchange(value);
      break;
    case 2:
      var value = new proto.common.model.ExLedger.Data;
      reader.readMessage(value,proto.common.model.ExLedger.Data.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExLedger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExLedger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExLedger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchange();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.model.ExLedger.Data.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExLedger.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExLedger.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExLedger.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
amount: jspb.Message.getFieldWithDefault(msg, 3, ""),
fee: jspb.Message.getFieldWithDefault(msg, 4, ""),
acctype: jspb.Message.getFieldWithDefault(msg, 5, ""),
biztype: jspb.Message.getFieldWithDefault(msg, 6, ""),
direct: jspb.Message.getFieldWithDefault(msg, 7, ""),
createat: jspb.Message.getFieldWithDefault(msg, 8, 0),
updateat: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExLedger.Item}
 */
proto.common.model.ExLedger.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExLedger.Item;
  return proto.common.model.ExLedger.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExLedger.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExLedger.Item}
 */
proto.common.model.ExLedger.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAcctype(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBiztype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirect(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreateat(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdateat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExLedger.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExLedger.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExLedger.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAcctype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBiztype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDirect();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreateat();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUpdateat();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string amount = 3;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string fee = 4;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string accType = 5;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getAcctype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setAcctype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string bizType = 6;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getBiztype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setBiztype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string direct = 7;
 * @return {string}
 */
proto.common.model.ExLedger.Item.prototype.getDirect = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setDirect = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 createAt = 8;
 * @return {number}
 */
proto.common.model.ExLedger.Item.prototype.getCreateat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setCreateat = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 updateAt = 9;
 * @return {number}
 */
proto.common.model.ExLedger.Item.prototype.getUpdateat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Item} returns this
 */
proto.common.model.ExLedger.Item.prototype.setUpdateat = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.ExLedger.Data.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExLedger.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExLedger.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExLedger.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
currentpage: jspb.Message.getFieldWithDefault(msg, 1, 0),
pagesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalpage: jspb.Message.getFieldWithDefault(msg, 4, 0),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.common.model.ExLedger.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExLedger.Data}
 */
proto.common.model.ExLedger.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExLedger.Data;
  return proto.common.model.ExLedger.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExLedger.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExLedger.Data}
 */
proto.common.model.ExLedger.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentpage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalpage(value);
      break;
    case 5:
      var value = new proto.common.model.ExLedger.Item;
      reader.readMessage(value,proto.common.model.ExLedger.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExLedger.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExLedger.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExLedger.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExLedger.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentpage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalpage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.common.model.ExLedger.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 currentPage = 1;
 * @return {number}
 */
proto.common.model.ExLedger.Data.prototype.getCurrentpage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Data} returns this
 */
proto.common.model.ExLedger.Data.prototype.setCurrentpage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 pageSize = 2;
 * @return {number}
 */
proto.common.model.ExLedger.Data.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Data} returns this
 */
proto.common.model.ExLedger.Data.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 totalNum = 3;
 * @return {number}
 */
proto.common.model.ExLedger.Data.prototype.getTotalnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Data} returns this
 */
proto.common.model.ExLedger.Data.prototype.setTotalnum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 totalPage = 4;
 * @return {number}
 */
proto.common.model.ExLedger.Data.prototype.getTotalpage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger.Data} returns this
 */
proto.common.model.ExLedger.Data.prototype.setTotalpage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Item items = 5;
 * @return {!Array<!proto.common.model.ExLedger.Item>}
 */
proto.common.model.ExLedger.Data.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.common.model.ExLedger.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.ExLedger.Item, 5));
};


/**
 * @param {!Array<!proto.common.model.ExLedger.Item>} value
 * @return {!proto.common.model.ExLedger.Data} returns this
*/
proto.common.model.ExLedger.Data.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.common.model.ExLedger.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.ExLedger.Item}
 */
proto.common.model.ExLedger.Data.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.common.model.ExLedger.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.ExLedger.Data} returns this
 */
proto.common.model.ExLedger.Data.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 exchange = 1;
 * @return {number}
 */
proto.common.model.ExLedger.prototype.getExchange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExLedger} returns this
 */
proto.common.model.ExLedger.prototype.setExchange = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Data data = 2;
 * @return {?proto.common.model.ExLedger.Data}
 */
proto.common.model.ExLedger.prototype.getData = function() {
  return /** @type{?proto.common.model.ExLedger.Data} */ (
    jspb.Message.getWrapperField(this, proto.common.model.ExLedger.Data, 2));
};


/**
 * @param {?proto.common.model.ExLedger.Data|undefined} value
 * @return {!proto.common.model.ExLedger} returns this
*/
proto.common.model.ExLedger.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.model.ExLedger} returns this
 */
proto.common.model.ExLedger.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.model.ExLedger.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.common.model);
